module.exports = __webpack_public_path__ + "img/政策法规.7c589c08.png";